module.exports = __webpack_public_path__ + "img/logo-bg-white.03048bc2.png";